export default __webpack_public_path__ + "static/media/banner5b.46b55f5d.jpg";